// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zYNj","footer":"styles_footer__203M2"};